// extracted by mini-css-extract-plugin
var _1 = "Badges-modulerightMargin__lf4g8";
export { _1 as "rightMargin" }
